// Gian của nhà bán (BV-2164): một nhà bán có thể có nhiều gian (seller_store), mỗi SKU nằm trong đúng một gian — product-v2
// trả `storeCode` trên SKU, rỗng = gian mặc định (`seller.sellerStore`). seller-core trả sẵn trên mỗi gian `productFilter`
// (trộn vào filter tìm SP) và `hasSubdomain` (dựng link), nên web không cần biết gian thuộc loại nào. File thuần, không import,
// để dùng chung client / server.

/**
 * Nhà bán theo gian chứa SKU: `storeCode` khớp một gian đang bật trong `seller.subStores` → bản sao seller mang tên / logo /
 * slug / link / productFilter của gian đó, để thẻ SP, trang SP hiện đúng gian. SKU ở gian mặc định (hoặc thiếu dữ liệu) →
 * trả nguyên seller. Đơn / hoá đơn không dùng hàm này (giữ nhà bán).
 * @param {object} seller seller đã convertSeller (có `subStores` từ seller/code?getStoreInfo=true)
 * @param {string} storeCode `storeCode` của SKU
 * @returns {object}
 */
export function sellerForStore(seller, storeCode) {
  if (!seller || !storeCode || !Array.isArray(seller.subStores)) {
    return seller;
  }
  const store = seller.subStores.find((item) => item?.code === storeCode);
  if (!store || store.status !== 'ACTIVE' || !store.slug) {
    return seller;
  }

  const { name = '', slug, logo = [], landingPages = [] } = store;
  return {
    ...seller,
    // tên hiển thị: getSellerData lấy name → shortName → displayName, PDP còn trộn sellerName từ BFF
    name,
    fullName: name,
    shortName: name,
    displayName: name,
    sellerName: name,
    slug,
    slugStore: slug,
    storeSlug: slug,
    sellerStore: store,
    statusStore: store.status,
    landingPage: (landingPages?.length > 0 && landingPages[0]) || '',
    avatar: logo,
    // số SP của nhà bán không đúng cho gian này — chỉ hiện khi seller-core trả số của gian (0 = ẩn)
    numberProducts: store.numberProducts || 0,
    isStore: true,
    // gian FLAGSHIP: link trang flagship, nhãn / huy hiệu Flagship (isVip ở web chỉ dùng để hiển thị)
    isVip: seller.isVip || store.storeType === 'FLAGSHIP',
    productFilter: store.productFilter,
  };
}
